export const GROW_GUIDE_FREE_GATE = 'GrowthCoaching:GrowGuide:Free';
export const GROW_GUIDE_USER_GUIDE_EXPERIMENT_GATE = 'GrowthCoaching:COAC0003';